import { getFetchOptions } from "../utils";
export function getCityFiasFromSuggestion(suggestion) {
    var _a;
    return (_a = suggestion.data.settlement_fias_id) !== null && _a !== void 0 ? _a : suggestion.data.city_fias_id;
}
export function isInsideBeltway(suggestion) {
    var _a;
    return ['IN_MKAD', 'IN_KAD'].includes((_a = suggestion === null || suggestion === void 0 ? void 0 : suggestion.data) === null || _a === void 0 ? void 0 : _a.beltway_hit);
}
export function useDeliveryApi() {
    function getDeliveryInfoFromSuggestion(suggestion, addExtraDay) {
        return getDeliveryInfo(suggestion.data.region, getCityFiasFromSuggestion(suggestion), suggestion.data.postal_code, addExtraDay, isInsideBeltway(suggestion));
    }
    function getAddressInfo(id) {
        return fetch('/api/address_info', getFetchOptions({ id: id }, true)).then(function (response) { return response.json(); });
    }
    function getAddressesInfo() {
        return fetch('/api/addresses_info', getFetchOptions(null, true)).then(function (response) { return response.json(); });
    }
    function getDeliveryInfo(region, fias, zip, addExtraDay, insideBeltway) {
        if (insideBeltway === void 0) { insideBeltway = false; }
        return fetch('/api/delivery_calculator', getFetchOptions({ addExtraDay: addExtraDay, region: region, fias: fias, zip: zip, insideBeltway: !!insideBeltway }, true))
            .then(function (response) { return response.json(); });
    }
    function getCDEKPoints(suggestion) {
        return fetch('/api/cdek/points', getFetchOptions({ fias: suggestion.region_fias_id }))
            .then(function (response) { return response.json(); });
    }
    function getCDEKPointInfo(id) {
        return fetch('/api/cdek/point_info', getFetchOptions({ id: id }))
            .then(function (response) { return response.json(); });
    }
    return {
        getAddressInfo: getAddressInfo,
        getAddressesInfo: getAddressesInfo,
        getDeliveryInfo: getDeliveryInfo,
        getDeliveryInfoFromSuggestion: getDeliveryInfoFromSuggestion,
        getCDEKPoints: getCDEKPoints,
        getCDEKPointInfo: getCDEKPointInfo,
    };
}
